import { render, staticRenderFns } from "./tahapanSeleksi.vue?vue&type=template&id=6884f8a0"
import script from "./tahapanSeleksi.vue?vue&type=script&lang=js"
export * from "./tahapanSeleksi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports